import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'fi-page-header-button-group',
    template: `
        @if (isMenuAvailable && isNewMenu) {
          <button
            mat-icon-button
            class="fi-menu-trigger-button show-mobile"
            [matMenuTriggerFor]="pageHeaderButtonsMenu"
            >
            <mat-icon class="fas fa-ellipsis-v"></mat-icon>
          </button>
        }
        @if (isMenuAvailable && !isNewMenu) {
          <button
            class="Ccm-Button btn btn-default show-mobile"
            [matMenuTriggerFor]="pageHeaderButtonsMenu"
            >
            <span class="button-text-small fa fa-pencil-square-o"></span>
          </button>
        }
        
        @if (isDeleteButtonShown) {
          <button
            mat-raised-button
            [class.mat-raised-button]="isMatRaisedButtonStyle"
            [class.btn]="isDefaultButton"
            class="fi-page-header-button Ccm-Button btn-default hide-mobile"
            (click)="deleteItem()"
            >
            {{ 'common.delete' | fiAppText }}
          </button>
        }
        @if (isEditButtonShown) {
          <button
            mat-raised-button
            [class.mat-raised-button]="isMatRaisedButtonStyle"
            [class.btn]="isDefaultButton"
            class="fi-page-header-button Ccm-Button btn-default hide-mobile"
            (click)="editItem()"
            >
            {{ 'common.edit' | fiAppText }}
          </button>
        }
        
        <mat-menu #pageHeaderButtonsMenu>
          @if (isAddNewButtonShown) {
            <button mat-menu-item (click)="addNewItem()">
              {{ addNewButtonText }}
            </button>
          }
          @if (isDeleteButtonShown) {
            <button mat-menu-item (click)="deleteItem()">
              {{ 'common.delete' | fiAppText }}
            </button>
          }
          @if (isEditButtonShown) {
            <button mat-menu-item (click)="editItem()">
              {{ 'common.edit' | fiAppText }}
            </button>
          }
        </mat-menu>
        `,
    styleUrls: ['./fi-page-header-button-group.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-page-header-button-group' },
    standalone: false,
})
export class FiPageHeaderButtonGroupComponent implements OnInit {
    @Input() isNewMenu: boolean;
    @Input() isEditButtonShown: boolean;
    @Input() isAddNewButtonShown: boolean;
    @Input() isDeleteButtonShown: boolean;
    @Input() isMatRaisedButtonStyle: boolean = false;
    @Input() isDefaultButton: boolean = true;
    @Input() addNewButtonText: string;
    @Output() onDeleteButtonClick = new EventEmitter();
    @Output() onEditButtonClick = new EventEmitter();
    @Output() onAddNewButtonClick = new EventEmitter();
    isMenuAvailable: boolean = false;

    ngOnInit(): void {
        this.isMenuAvailable = this.isAddNewButtonShown || this.isDeleteButtonShown || this.isEditButtonShown;
    }

    addNewItem(): void {
        this.onAddNewButtonClick.emit();
    }

    deleteItem(): void {
        this.onDeleteButtonClick.emit();
    }

    editItem(): void {
        this.onEditButtonClick.emit();
    }
}
